<template>
  <div>
    <h2>JSON Edit Test</h2>
    <div style="width:50%;margin-left:25%;height:100%;;background:lime;">
      <v-jsoneditor style="height:100%;width:100%;" v-model="json" :options="options" :plus="false"  @error="onError">
      </v-jsoneditor>
    </div>
  </div>
</template>
<script>

import VJsoneditor from 'v-jsoneditor'


export default {
  name: 'JSONedit',
  components: {
      VJsoneditor
  },
  data() {
      return {
        options: {
          allErrors: true, 
          verbose: true,
          jsonPointers: false,
          $data: true,
          templates: [
        {
            text: 'Person',
            title: 'Insert a Person Node',
            className: 'jsoneditor-type-object',
            field: 'PersonTemplate',
            value: {
                'firstName': 'John',
                'lastName': 'Do',
                'age': 28
            }
        },
        {
            text: 'Address',
            title: 'Insert a Address Node',
            field: 'AddressTemplate',
            value: {
                'street': "",
                'city': "",
                'state': "",
                'ZIP code': ""
            }
        }
    ]

        },
        json: {
            "hello": "vue",
            "myArray": [
              "one","two","three"
            ]
        }
      }
  },
  methods: {
      onError() {
          console.log('error')
      }
  }
}
</script> 